import Tracker from 'gatsby-core-theme/src/components/pages/tracker/index-ssr';
import { getAffiliateLink } from '~helpers/tracker';
import React from 'react';

export default (props) => (
  <Tracker
    {...props}
    mainText={'Please wait a moment, whilst we redirect you to [operator_name]'}
    redirectText={'If the site is not navigated within 10 seconds click below...'}
    btnText={'Redirect Manually'}
    bgImage={`${process.env.ASSETS_URL}images/splash-page-bg.jpeg`}
    logo={`${process.env.ASSETS_URL}images/logo.svg`}
  />
);

export async function getServerData({ pageContext, headers, url }) {
  let res = '';
  res = await getAffiliateLink(
    pageContext.operator,
    pageContext.page.path,
    pageContext.page,
    headers,
    url
  );
  return res;
}